import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import { listQueryToApiParams } from '#/utils/listUrl/parseListSearchParams';

export async function fetchStocktakeList(listQuery) {
  const { data: raw } = await request.get('/ims/stocktake', {
    params: listQueryToApiParams(listQuery),
  });
  return parseVer4ListResponse(raw);
}
